import { render, staticRenderFns } from "./Settlement.vue?vue&type=template&id=e23d3cca&"
import script from "./Settlement.vue?vue&type=script&lang=js&"
export * from "./Settlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports